import DynamicTable from '@atlaskit/dynamic-table';
import type { HeadType, RowType } from '@atlaskit/dynamic-table/dist/types/types';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives';

import { SearchInput } from './search-input';
import { ROWS_PER_PAGE } from './types';

type SettingsListProps = {
	headingText: string;
	error: string | null;
	tableHead: HeadType;
	tableRows: RowType[];
	loading?: boolean | null;
	rowsPerPage?: number;
	currentPage?: number;
	setCurrentPage?: (page: number) => void;
	onSearch?: (input: string) => void;
	searchPlaceholder?: string;
};
export const SettingsList = ({
	headingText,
	error,
	tableHead,
	tableRows,
	loading,
	rowsPerPage = ROWS_PER_PAGE,
	currentPage,
	setCurrentPage,
	onSearch,
	searchPlaceholder,
}: SettingsListProps) => (
	<Stack space="space.150">
		<Heading as="h3" size="small">
			{headingText}
		</Heading>
		{onSearch && (
			<SearchInput onSearch={onSearch} testId="settings-list" placeholder={searchPlaceholder} />
		)}
		{error ? (
			<Text>{error}</Text>
		) : (
			<DynamicTable
				isFixedSize
				head={tableHead}
				rows={tableRows}
				rowsPerPage={rowsPerPage}
				page={currentPage}
				onSetPage={setCurrentPage}
				isLoading={loading ?? false}
				emptyView={<Text>No results were found.</Text>}
			/>
		)}
	</Stack>
);
